export default "/assets/images/home-wrecker3.png?34e9e14aa4ab68b02e4af9ab9f432f35";